// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"2057":"3ef614c5","5415":"be362223"}[chunkId] + ".chunk.js");